import Page from '~/pages_components/services'

export default Page
